module.exports = __webpack_public_path__ + "img/n1.48d7087a.png";